//#region Imports
// No imports in this file
//#endregion

//#region Class/Component Definition
export class GlobalAppUrls {
    //#region Properties & State
    //#region Client URLs
    public Client = {
        //#region Account URLs
        Account: {
            ConfirmEmail: "/account/confirmemail/:token",
            ForgotPassword: "/account/forgotpassword",
            ForgotPasswordSuccess: "/account/forgotpassword-success",
            Login: "/account/login",
            Logout: "/logout",
            Register: "/account/register",
            RegisterSuccess: "/account/register/success",
            ResetPassword: "/account/resetpassword/:token",
            SessionExpired: "/sessionexpired",
        },
        //#endregion

        //#region Admin URLs
        Admin: {
            AdminHome: "/admin/dashboard/userslist",
            LogViewer: "/admin/logviewer",
            Mentor: {
                Resources: "/mentor/resources",
                Root: "/mentor",
                WeeklyRota: "/mentor/weeklyrota",
            },
        },
        //#endregion

        //#region Attendance URLs
        Attendance: {
            Home: "/attendance",
        },
        //#endregion

        //#region General URLs
        ColoursMUI: "/coloursmui",
        DashBoard: "/dashboard",
        Demo: "/application/personalinfo",
        Error: "/error",
        Home: "/",
        //#endregion

        //#region Mentors URLs
        Mentors: {
            MentorDetail: {
                Edit: "/mentors/mentor/:id",
                Root: "mentors/mentor",
            },
            Root: "/mentors",
            Current: "/mentors/current",
            Past: "/mentors/past",
        },
        //#endregion

        //#region Miscellaneous URLs
        NotFound: "/notfound",
        PageBuilder: "/pagebuilder",
        PrivacyPolicy: "/privacy-policy",
        //#endregion

        //#region Reports URLs
        Reports: {
            Root: "/reports/*",
            Home: "/reports",
        },
        //#endregion

        //#region Resources URLs
        Resources: {
            Home: "/resources",
        },
        //#endregion

        //#region Sample URLs
        Samples: "/samples/text",
        //#endregion

        //#region Students URLs
        Students: {
            Current: "/students/live",
            Enquiry: "/students/enquiry",
            Outreach: "/students/outreach",
            Past: "/students/past",
            Root: "/students",
            Student: {
                StudentCare: {
                    Edit: "/students/care/:id",
                    Root: "/students/care",
                },
                StudentDetail: {
                    Add: "/students/student/new",
                    Edit: "/students/student/:id",
                    Root: "/students/student",
                },
                StudentDocuments: {
                    Edit: "/students/documents/:id",
                    Root: "/students/documents",
                },
                StudentRiskAssessmentDocuments: {
                    Edit: "/students/riskassessment/:id",
                },
                StudentGrabSheet: {
                    Edit: "/students/student/grabsheet/edit/:id",
                },
                StudentReports: {
                    Add: "/students/reports/report/:reportId",
                    Edit: "/students/reports/:id",
                    New: "/students/reports/:studentId/report/new",
                    Root: "/students/reports",
                },
                StudentTargets: {
                    Active: "/students/targets/:id/active",
                    Completed: "/students/targets/:id/completed",
                    Edit: "/students/targets/:id",
                    EditTarget: "/students/targets/:id/edit/:targetId",
                    Root: "/students/targets",
                },
                StudentTimeTable: {
                    Edit: "/students/timetable/:id",
                    Root: "/students/timetable",
                },
            },
        },
        //#endregion

        //#region Utility URLs
        StyleSheet: "/stylesheet",
        Terms: "/terms",
        Test: "/test",
        Theme: "/theme",
        Todo: "/todo",
        //#endregion

        //#region Weekly Rota URLs
        WeeklyRota: {
            AddWeeklyRotaReport: "/mentor/weeklyrota/student/:studentId/mentor/:mentorId/report/:id",
            DetailsWeeklyRotaReport: "/mentor/weeklyrota/reports/report/:reportId",
            Home: "/weeklyrota",
            WeeklyRotaDetail: {
                Edit: "/weeklyrota/:id",
            },
        },
        //#endregion

        Blank: "/blank",
    };
    //#endregion

    //#region Server URLs
    public Server = {
        //#region Account API URLs
        Account: {
            ForgotPassword: "/api/account/forgotpassword",
            Login: "/api/account/login",
            Logout: "/api/account/logout",
            Register: "/api/account/register",
            ResendEmailConfirmation: "api/account/resendemailconfirmation",
            ResetPassword: {
                Reset: "/api/account/resetpassword",
                VerifyToken: "/api/account/resetpasswordtoken",
            },
            SetPassword: "/api/account/setpassword",
            CreateNewPassword: "/api/account/createnewpassword",
            User: {
                DeleteRole: "/api/role/delete",
                DeleteUser: "/api/user/delete",
            },
        },
        //#endregion

        //#region Admin API URLs
        Admin: {
            GetRoles: "/api/roles/getall",
            ResetFailedLoginAttemptsCount: "/api/user/ResetLoginAttempts",
        },
        //#endregion

        //#region Attendance API URLs
        Attendance: {
            GetAttendanceReport: "/api/student/getattendancereport",
            GetAttendanceReportAndRelated: "/api/student/getattendancereportandrelated",
        },
        //#endregion

        //#region Initial State API URLs
        InitialState: {
            Initialize: "/api/initialstate",
        },
        //#endregion

        //#region Mentor API URLs
        Mentor: {
            DeleteMentorById: "/api/mentor/deletementor/:id",
            GetAllMentors: "/api/mentor/getallmentorslite",
            GetMentorById: "/api/mentor/getmentordetailsbyid/:id",
            SaveMentor: "/api/mentor/savementor",
            GetMentorsCount: "/api/mentor/getmentorscount",
            GetFilteredMentors: "/api/mentor/getfilteredmentors",
            UpdateMentorStatus: "/api/mentor/updatestatus",
        },
        //#endregion

        //#region Mentor Role API URLs
        MentorRole: {
            EditStudentAttendend: "/api/student/editstudentsession",
            GetAllMentors: "/api/mentor/getallmentorslite",
            GetMentorsSessionReports: "/api/mentor/getallmentorsessionreport/:startdate",
        },
        //#endregion

        //#region Resources API URLs
        Resources: {
            GetAllResourceDocuments: "/api/resource/getallresourcedocuments",
            GetResourceDocumentForDownloadById: "/api/resource/getresourcedocumentfordownloadbyid/:id",
            PostDeleteResourceDocumentById: "/api/resource/deleteresourcedocumentbyid/:id",
            PostInsertResourceDocument: "/api/resource/insertresourcedocument",
        },
        //#endregion

        //#region Reports API URLs
        Reports: {
            ExportStudentProgressReport: "/api/report/exportstudentprogressreport",
        },
        //#endregion

        //#region Student API URLs
        Student: {
            DeleteStudentById: "/api/student/deletestudent/:id",
            GetAllStudents: "/api/student/getallstudentslite",
            GetFilteredStudentList: "/api/student/getfilteredstudentlist",
            GetStudentDetailsById: "/api/student/getstudentdetailsbyid/:id",
            GetStudentsCount: "/api/student/getstudentscount",
            PostSaveStudent: "/api/student/savestudent",
            GetFilteredStudentKeyValuePairs: "/api/student/getfilteredstudentkeyvaluepairs",

            //#region Student Care API URLs
            StudentCare: {
                GetStudentCareById: "/api/student/getstudentcarebyid/:id",
                PostSaveStudentCare: "/api/student/savestudentcare",
            },
            //#endregion

            //#region Student Documents API URLs
            StudentDocuments: {
                GetAllStudentDocumentsLite: "/api/student/getallstudentdocumentslite/:id",
                GetStudentDocumentAndSessionDocumentsByFilters: "/api/student/getstudentdocumentandsessiondocumentsbyfilters",
                GetStudentDocument: "/api/student/getstudentdocumentbyid/:id",
                PostSaveStudentDocument: "/api/student/savestudentdocument",
                SoftDeleteStudentDocumentById: "/api/student/deletestudentdocument/:id",
            },
            //#endregion

            //#region Student Grab Sheet API URLs
            StudentGrabSheet: {
                GetByStudentId: "/api/student/grabsheet/:studentId",
                Save: "/api/student/grabsheet",
            },
            //#endregion

            //#region Student Risk Assessment Documents API URLs
            StudentRiskAssessmentDocuments: {
                GetStudentRiskAssessmentDocumentsByStudentId: "/api/student/getstudentriskassessmentdocumentsbystudentid",
                GetStudentRiskAssessmentDocumentById: "/api/student/getstudentriskassessmentdocumentbyid/:id",
                PostSaveStudentRiskAssessmentDocument: "/api/student/savestudentriskassessmentdocument",
                SoftDeleteStudentRiskAssessmentDocumentById: "/api/student/deletestudentriskassessmentdocument/:id",
            },
            //#endregion

            //#region Student Sessions API URLs
            StudentSessions: {
                GetAllStudentSessionReportsLite: "/api/student/getallstudentSessionReportslite/:id/{startdate}/{enddate}",
                GetStudentDocumentForDownloadById: "/api/student/getstudentsessiondocumentbyid/:id",
                GetNewStudentSessionReportContext: "/api/student/getnewstudentsessionreportcontext/:studentId",
                GetStudentSessionContextById: "/api/student/getstudentsessioncontextbyid/:id",
                PostSaveSessionActivity: "/api/student/saveactivity",
                PostSaveStudentSession: "/api/student/savestudentsession",
                PostSaveStudentSessionDocument: "/api/student/savestudentsessiondocument",
                ExportStudentSessionReportPDF: "/api/student/studentsession/exportreportpdf",
            },
            //#endregion

            //#region Student SubTarget API URLs
            StudentSubTarget: {
                Delete: "/api/student/deletestudentsubtarget",
                Insert: "/api/student/insertstudentsubtarget",
                UpdateCompletedStatus: "/api/student/updatestudentsubtargetcompletedstatus",
                Update: "/api/student/updatestudentsubtarget",
            },
            //#endregion

            //#region Student Target API URLs
            StudentTarget: {
                Delete: "/api/student/deletestudenttarget",
                EditStudentTarget: "/api/student/editstudenttargetdetails",
                GetStudentTargetById: "/api/student/getstudenttargetbyid/:id",
                GetStudentTargetDetailsById: "/api/student/getstudenttargetdetailsbyid/:id",
                Insert: "/api/student/insertstudenttarget",
                UpdateCompletedStatus: "/api/student/updatestudenttargetcompletedstatus",
                UpdateDescription: "/api/student/updatestudenttargetdescription",
            },
            //#endregion

            //#region Targets API URLs
            Targets: {
                GetActiveStudentTargetsAndRelated: "/api/student/getactivestudenttargetsandrelated/:id",
                GetCompletedStudentTargetsAndRelated: "/api/student/getcompletedstudenttargetsrelated/:id",
                GetNextAvailableStudentTargetReference: "/api/student/getnextavailablestudenttargetreference/:id",
            },
            //#endregion

            //#region TimeTable API URLs
            TimeTable: {
                GetStudentRotaById: "/api/student/getstudentrotabyid/:id",
                PostSaveStudentRota: "/api/student/savestudentrota",
            },
            //#endregion
        },
        //#endregion

        //#region Weekly Rota API URLs
        WeeklyRota: {
            DeleteMentorRotaAbsence: "/api/rota/deletementorrotaabsense",
            DeleteMentorStudent: "/api/rota/deletementorstudentrota",
            GetAllLeftStudentSession: "/api/student/getallleftstudentsession/:startdate",
            GetMentorStudentRotaById: "/api/rota/getmentorstudentrotabyid/:mentorStudentRotaId",
            GetWeeklyRotaByDate: "/api/rota/getrota",
            ResetRota: "/api/rota/resetrota/:startdate",
            SaveMentorRotaAbsence: "/api/rota/savementorrotaabsense",
            EditMentorStudentRota: "/api/student/editMentorStudentRota",
            SaveMentorStudentRota: "/api/rota/savementorstudentrota",
            SaveRota: "/api/rota/saverota",
        },
        //#endregion
    };
    //#endregion
}
//#endregion

//#region Exports
export const AppUrls = new GlobalAppUrls();
//#endregion
